import { logout, refreshToken } from "../actions/auth/auth";
import TokenService from "../services/token";
import axiosInstance from "./base-api";
import axiosInstanceAnalytics from "./analytics-api";
import refreshAxiosInstance from "./refersh-api";

// Default header settings
const configHeader = (config: any) => {
    const token = TokenService.getLocalAccessToken();
    if (token && !config.headers["Authorization"]) {
        config.headers["Authorization"] = `Bearer ${token}`;
        config.headers["Cache-Control"] = `no-cache, no-store, must-revalidate`;
        config.headers["Pragma"] = `no-cache`;
        config.headers["Expires"] = `0`;
    }
    return config;
};

const sendTokenInvalidEvent = () => {
    const event = new CustomEvent("tokenInvalid");
    window.dispatchEvent(event);
};

// Fetch new access token using refresh token
const updateNewAccessToken = async (originalConfig: any, instance = axiosInstance) => {
    originalConfig._retry = true;
    try {
        const expiredToken = TokenService.getLocalRefreshToken();

        const rs = await refreshAxiosInstance.post("/auth/v1/refresh", {
            refreshToken: expiredToken,
        });

        const { accessToken } = rs.data.data;

        refreshToken(accessToken);

        TokenService.updateLocalAccessToken(accessToken);

        originalConfig.headers["Authorization"] = `Bearer ${accessToken}`;
        window.location.reload(false);
        return instance(originalConfig);
    } catch (error) {
        logout();
        TokenService.removeUser();
        window.location.href = "/login";
        return Promise.reject(error);
    }
};

const setupInterceptors = (): void => {
    axiosInstance.interceptors.request.use(configHeader, (error) => Promise.reject(error));

    axiosInstance.interceptors.response.use(
        (res) => res,
        async (err) => {
            const originalConfig = err.config;

            if (originalConfig.url !== "/auth/basic" && err.response) {
                // Access Token was expired
                if (
                    (err.response.status === 403 || err.response.status === 401) &&
                    !originalConfig._retry
                ) {
                    if (err.response.status === 403) {
                        sendTokenInvalidEvent();
                    }
                    originalConfig._retry = true;
                    updateNewAccessToken(originalConfig);
                }
            }

            return Promise.reject(err);
        }
    );

    axiosInstanceAnalytics.interceptors.request.use(configHeader, (error) => Promise.reject(error));

    axiosInstanceAnalytics.interceptors.response.use(
        (res) => res,
        async (err) => {
            const originalConfig = err.config;

            if (err.response) {
                // Access Token was expired
                if (
                    (err.response.status === 403 || err.response.status === 401) &&
                    !originalConfig._retry
                ) {
                    if (err.response.status === 403) {
                        sendTokenInvalidEvent();
                    }
                    updateNewAccessToken(originalConfig, axiosInstanceAnalytics);
                }
            }

            return Promise.reject(err);
        }
    );
};

export default setupInterceptors;
